"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _recompose = require("recompose");

var _heading = _interopRequireDefault(require("../heading"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _recompose.compose)((0, _recompose.setPropTypes)({
  level: _propTypes.default.number
}), (0, _recompose.withProps)({
  level: 2
}), (0, _recompose.setDisplayName)('ModalTitle'))(_heading.default);

exports.default = _default;